module.exports = __webpack_public_path__ + "media/images/hitfun/sample.adv.2-38a32bc084155ff9df7526f34106339d.jpg";